<div class="search-results-pagination">
  <span class="search-results-header">
    {{ searchResultsTranslationKey | translate: { value: totalSearchResults || 0 } }}
  </span>

  @if (shouldShowControls) {
    <div class="prev-next-buttons">
      <button
        data-test-id="prev-btn"
        class="prev-btn"
        [ngClass]="{ 'disabled pointer-events-none': isPrevButtonDisabled }"
        [disabled]="isNavigationDisabled"
        (click)="goToPrevSearchHighlight()"
      >
        <svg-icon src="open-arrow-icon" preserveAspectRatio="none" [stretch]="true"></svg-icon>
      </button>

      <div class="pagination-progress">
        <span class="current-page">{{ currentPageNumber }}</span>
        <span>&nbsp;/&nbsp;</span>
        <span class="total-pages">{{ totalSearchResults || 0 }}</span>
      </div>

      <button
        data-test-id="next-btn"
        class="next-btn"
        [ngClass]="{
          'disabled pointer-events-none': isNextButtonDisabled,
        }"
        (click)="goToNextSearchHighlight()"
      >
        <svg-icon src="open-arrow-icon" preserveAspectRatio="none" [stretch]="true"></svg-icon>
      </button>
    </div>
  }

  <button
    data-test-id="clear-search-button"
    class="font-main text-lg text-white py-1 px-3 rounded-full bg-navy-80 hover:bg-navy-90 outline-none h-auto clear-search border-none"
    (click)="clearSearch()"
  >
    {{ clearSearchTranslationKey | translate }}
  </button>
</div>
